<div>
    <p-toolbar>
        <!-- <p-messages style="margin-top: 0 !important;" *ngIf="showTimer" [(value)]="processingMsg"></p-messages> -->
    </p-toolbar>
    <p-table stripedRows #ScheduleTable [scrollable]="true" scrollHeight="60vh"
        [value]="schedules" dataKey="ProcessScheduleID" [(selection)]="this.selectedSchedule"
        selectionMode="single" (onRowSelect)="onScheduleSelected($event)">
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="17" style="text-align: center">
                    <div class="tabulator-placeholder">
                        <span> No Data Available </span>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template #header>
            <tr>
                <th style="width: 100%; text-align: center; justify-content: center;" class="colgroup" colspan="8">PROCESS SCHEDULE</th>
            </tr>
            <tr>
                <th class="status-cell">
                    <i class="pi pi-exclamation-circle" title="Status"></i>
                </th>
                <th class="select-cell">
                    <i class="pi pi-pen-to-square" title="Select"></i>
                </th>
                <th pSortableColumn="PeriodStartDate">
                    Period Start
                    <p-sortIcon field="PeriodStartDate" ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order">
                    </p-sortIcon>
                </th>
                <th pSortableColumn="PeriodEndDate">
                    Period End
                    <p-sortIcon field="PeriodEndDate" ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order">
                    </p-sortIcon>
                </th>

                <th pSortableColumn="PeriodStatus">
                    Period Status
                    <p-sortIcon field="PeriodStatus" ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order">
                    </p-sortIcon>
                </th>
                <th pSortableColumn="QBImportDate">
                    QuickBooks Import
                    <p-sortIcon field="QBImportDate" ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order">
                    </p-sortIcon>
                </th>
                <th pSortableColumn="EFCommitDate">
                    eFAACT Commit
                    <p-sortIcon field="EFCommitDate" ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order">
                    </p-sortIcon>
                </th>
                <th pSortableColumn="EFCommitDate">
                    GL Sync
                    <p-sortIcon field="EFCommitDate" ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order">
                    </p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-schedule>
            <tr data-id="row-{{ schedule.ProcessScheduleID }}" [pSelectableRow]="schedule">
                <td class="status-cell">
                    <a (click)="onStatusClick(schedule)">
                        <div>
                            <ef-status-icon [status]="
                                    schedule?.Status?.StatusCode
                                        " [message]="
                                        schedule?.Status?.Message
                                        "></ef-status-icon>
                        </div>
                    </a>
                </td>
                <td class="select-cell">
                    <p-checkbox title="A schedule cannot be selected until an import from QuickBooks is completed for the period." value="schedule" [value]="schedule.ProcessScheduleID"
                        [inputId]="schedule.ProcessScheduleID" [(ngModel)]="this.selectedProcessScheduleIDs" (onChange)="onCheckboxChange($event, schedule)"></p-checkbox>
                </td>
                <td>
                    <span *ngIf="schedule.PeriodStartDate != null">
                        {{ moment(schedule.PeriodStartDate).format('MM/DD/YYYY') }}
                    </span>
                </td>
                <td>
                    <span *ngIf="schedule.PeriodEndDate != null">
                        {{ moment(schedule.PeriodEndDate).format('MM/DD/YYYY') }}
                    </span>
                </td>
                <td class="large-cell">
                    <span [title]="schedule.PeriodStatus">
                        {{ schedule.PeriodStatus }}
                    </span>
                </td>
                <td>
                    <span *ngIf="schedule.QBImportDate != null">
                        {{ moment(schedule.QBImportDate).format('MM/DD/YYYY') }}
                    </span>
                </td>
                <td>
                    <span *ngIf="schedule.EFCommitDate != null">
                        {{ moment(schedule.EFCommitDate).format('MM/DD/YYYY') }}
                    </span>
                </td>
                <td>
                    <span *ngIf="schedule.GLSyncDate != null">
                        {{ moment(schedule.GLSyncDate).format('MM/DD/YYYY') }}
                    </span>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>


<!-- <p-accordionTab header="Contract Invoice Schedule" [selected]="true">

        </p-accordionTab>

        <p-accordionTab header="Period Process Settings" [selected]="true">
            <p-toolbar>
            </p-toolbar>
            <p-table stripedRows #ContractsTable
                [scrollable]="true"
                [style]="{ 'max-width': '100%' }"
                scrollHeight="23.5vh"
                [value]="settings"
                dataKey="id"
                [virtualRowHeight]="10"
                [(selection)]="this.selectedSetting"
                selectionMode="single"
                (onRowSelect)="onSettingSelected($event)"
                [virtualScroll]="true"
            >

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="17" style="text-align: center">
                            <div class="tabulator-placeholder">
                                <span> No Data Available </span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr class="tabulator-header">
                        <th style="text-align: center" class="small-cell">
                            <i class="fa far fa-edit" style="font-size: 1.5em" title="Select"></i>
                        </th>
                        <th pSortableColumn="" class="small-cell">
                            <div class="tabulator-col-content">
                                Setting
                                <p-sortIcon field="" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <th class="tabulator-header-filter"></th>
                        <th class="tabulator-header-filter"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-setting>
                    <tr class="tabulator-row" data-id="row-{{ setting.id }}" [pSelectableRow]="setting">
                        <td class="small-cell" style="text-align: center; align-items: center">
                            <p-checkbox></p-checkbox>
                        </td>
                        <td class="small-cell">

                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-accordionTab> -->
